const prefix = '[Kpis]';

export class LoadAllKpis {
    static readonly type = `${prefix} Load All`;
}
